const BillingCycle = {
  MONTHLY: "MONTHLY",
  ANNUAL: "ANNUALLY",
};

export default BillingCycle;